<template>
  <div class="remote-play-container">
    <!-- 标签页切换 -->
    <div class="tab-header">
      {{this.$t("remote_room_code")}}{{this.searchResultForm.roomId}}
      <span class="time-remaining">({{ this.remainingTimeDisplay }})</span>
    </div>
    <div class="form-group">
      <div style="display: flex; align-items: center; width: 100%;">
        <label>{{this.$t("describe_remote_play")}}</label>
      </div>
    </div>


      <div v-if="activeTab === 'CustomMotions'" class="tab-content create-room">
        <div class="two-column-layout">
          <!-- 左侧区域 -->
          <div class="left-section">
            <div class="container">
              <!-- 头像展示区域 -->
              <div class="avatar-container">
                <div class="avatar-wrapper">
                  <img :src="this.user.avatarImg1" class="avatar">
                  <div class="avatar-label">{{this.$t("remote_room_avatar1")}}</div>
                </div>
                <div class="dots">
                  <span v-for="dot in dots" :key="dot" :class="{ online: searchResultForm.onLine === 2 }"></span>
                </div>
                <div class="avatar-wrapper">
                  <img :src="this.user.avatarImg2" class="avatar2">
                  <div class="avatar-label">{{this.$t("remote_room_avatar2")}}</div>
                </div>
              </div>

              <!-- 控制按钮 -->
              <div class="button-container">
                <div class="button-group">
                  <label>START</label>
                  <button class="image-button" @click="startRemotePlay">
                    <img :src="this.isStartRemotePlay === false && this.isRecipientStartRemotePlay === false
                    ? require('@/assets/remote/start_selected.png')
                    : require('@/assets/remote/start_default.png')" class="button-image" width="30" height="30">

                  </button>
                </div>
                <div class="button-group">
                  <button class="image-button" @click="stopRemotePlay">
                    <img :src="this.isStartRemotePlay === true || this.isRecipientStartRemotePlay === true
                    ? require('@/assets/remote/stop_selected.png')
                    : require('@/assets/remote/stop_default.png')" class="button-image" width="30" height="30">
                  </button>
                  <label>STOP</label>
                </div>
              </div>
              <!-- 自由模式 -->
              <div class="joystick-settings" style="position: relative">
                <div v-if="isRecipient" class="disabled-overlay"></div>
                <div :class="{'content-disabled': isRecipient}">
                  <div class="joystick-container">
                    <div class="joystick-wrapper">
                      <img :src="require(`@/assets/remote/action.png`)" width="31" height="40">
                      <div class="joystick-label">{{this.$t("remote_room_action")}}</div>
                    </div>
                    <div class="form-profile">
                      <div class="item-content" style="display: flex; align-items: center; justify-content: space-between;">
                       <label>{{this.$t("motion_current_profile_list")}}{{this.listSize}}</label>
                        <div class="edit-container">
                          <button @click="openScopeSetting()">
                            <img src="@/assets/motions/custom_motions.png" alt="Edit" />
                          </button>
                        </div>
                      </div>
                      <div class="motion-item" v-for="(item, index) in motionItems" :key="index">
                        <div class="item-content" style="display: flex; align-items: center;">
                          <div class="icon-container">
                            <img
                              :src="profileIndex === index
                              ? require('@/assets/motions/motion_mode_list_playing.png')
                              : require('@/assets/motions/motion_mode_list_run.png')"
                              alt="Motion Icon"
                            />
                          </div>
                          <div class="text-container"
                            :style="{ color: profileIndex === index ? '#8300F6' : '#333' }"
                            @click="selectProfile(index)"
                          >
                            {{ item.name }}
                          </div>
                          <div class="edit-container-item">
                            <button @click="openEditModal(item)">
                              <img src="@/assets/motions/motion_mode_list_item_edit.png" alt="Edit" width="14px" height="14px"/>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 分割线 -->
            <div class="mira-form-divider"></div>
            <!-- 摇杆设置 -->
            <div class="joystick-settings" style="position: relative">
              <div v-if="isRecipient" class="disabled-overlay"></div>
              <div :class="{'content-disabled': isRecipient}">
                <div class="joystick-container">
                  <div class="joystick-wrapper">
                    <img :src="require(`@/assets/remote/joystick.png`)" width="40" height="50">
                    <div class="joystick-label">{{this.$t("remote_room_joystick")}}</div>
                  </div>
                  <div class="slider-group">
                    <div class="slider-title">{{this.$t("remote_room_joystick_settings")}}</div>
                    <div class="slider-container">
                      <NumSlider class="slider-control"
                                 :min="0"
                                 :max="9999"
                                 :initialValue="0"
                                 :width="400"
                                 :disabled="false"
                                 :range="false"
                                 v-model="value"
                                 @change="onSliderChangeForL0ActionTest('L0', $event)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 中间间隔 -->
          <div class="section-gap"></div>

          <!-- 右侧区域 -->
          <div class="right-section">
            <div class="chart-grid">
              <div class="chart-item" >
                <div class="chart-title">Stroke(L0)</div>
                <LineChart ref="chartL0" :timeWindow="timeWindow" :height="'80px'"/>

                <div class="chart-title">Surge (L1)</div>
                <LineChart ref="chartL1" :timeWindow="timeWindow" :height="'80px'"/>

                <div class="chart-title">Sway (L2)</div>
                <LineChart ref="chartL2" :timeWindow="timeWindow" :height="'80px'"/>

                <div class="chart-title">Twist (R0) </div>
                <LineChart ref="chartR0" :timeWindow="timeWindow" :height="'80px'"/>

                <div class="chart-title">Roll (R1) </div>
                <LineChart ref="chartR1" :timeWindow="timeWindow" :height="'80px'"/>

                <div class="chart-title">Pitch (R2)</div>
                <LineChart ref="chartR2" :timeWindow="timeWindow" :height="'80px'"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 编辑模态框 -->
      <div v-if="showEditModal" class="modal-overlay" @click.self="closeEditModal">
        <Edit :item="editingItem" @close="closeEditModal" @update="updateItem" />
      </div>
      <!-- 范围选择对话框 -->
      <div v-if="showScopeSetting" class="avatar-dialog-overlay">
        <div class="avatar-dialog">
          <h3>{{this.$t("remote_room_scope_setting_title")}}</h3>

          <div class="slider-item" style="display: flex; align-items: center;">
            <label class="slider-label">L0</label>
            <NumSlider class="slider-control"
                       :min="0"
                       :max="9999"
                       :initialValue="sliderValues.L0"
                       :width="350"
                       :disabled="false"
                       :range="true"
                       v-model="sliderValues.L0"
                       @change="onSliderChange('L0', $event)"
            />
          </div>
          <div class="slider-item" style="display: flex; align-items: center;">
            <label class="slider-label">L1</label>
            <NumSlider class="slider-control"
                       :min="0"
                       :max="9999"
                       :initialValue="sliderValues.L1"
                       :width="350"
                       :disabled="false"
                       :range="true"
                       v-model="sliderValues.L1"
                       @change="onSliderChange('L1', $event)"
            />
          </div>
          <div class="slider-item" style="display: flex; align-items: center;">
            <label class="slider-label">L2</label>
            <NumSlider class="slider-control"
                       :min="0"
                       :max="9999"
                       :initialValue="sliderValues.L2"
                       :width="350"
                       :disabled="false"
                       :range="true"
                       v-model="sliderValues.L2"
                       @change="onSliderChange('L2', $event)"
            />
          </div>
          <div class="slider-item" style="display: flex; align-items: center;">
            <label class="slider-label">R0</label>
            <NumSlider class="slider-control"
                       :min="0"
                       :max="9999"
                       :initialValue="sliderValues.R0"
                       :width="350"
                       :disabled="false"
                       :range="true"
                       v-model="sliderValues.R0"
                       @change="onSliderChange('R0', $event)"
            />
          </div>
          <div class="slider-item" style="display: flex; align-items: center;">
            <label class="slider-label">R1</label>
            <NumSlider class="slider-control"
                       :min="0"
                       :max="9999"
                       :initialValue="sliderValues.R1"
                       :width="350"
                       :disabled="false"
                       :range="true"
                       v-model="sliderValues.R1"
                       @change="onSliderChange('R1', $event)"
            />
          </div>
          <div class="slider-item" style="display: flex; align-items: center;">
            <label class="slider-label">R2</label>
            <NumSlider class="slider-control"
                       :min="0"
                       :max="9999"
                       :initialValue="sliderValues.R2"
                       :width="350"
                       :disabled="false"
                       :range="true"
                       v-model="sliderValues.R2"
                       @change="onSliderChange('R2', $event)"
            />
          </div>

          <div class="dialog-buttons">
            <button class="dialog-btn cancel-btn" @click="cancelScopeSetting">{{this.$t("layout_cancel")}}</button>
            <button class="dialog-btn confirm-btn" @click="confirmScopeSetting">{{this.$t("layout_confirm")}}</button>
          </div>
        </div>
      </div>
      <!-- 会员对话框 -->
    <MemberDialog :showDialog.sync="showMemberDialog" @close="closeMemberDialog" />
    </div>
</template>

<script>
import * as motionApi from "@/api/platform/motions";
import * as cache from "@/utils/cache";
import * as user from "@/api/tcode/user";
import * as bridgeApi from "@/api/platform/bridge";
import Edit from "../motions/edit.vue";
import LineChart from './LineChart.vue';
import {findProfileListByUserPk, updateAllProfileAxisRangeOfUser} from "../../../api/platform/motions";
import NumSlider from '../motions/NumSlider.vue'; // 确保路径正确
import VerticalSlider from './VerticalSlider.vue'
import {TCodeProfilePlayer, MotionProfile} from "@/tcode/TCodeProfilePlayer2";
import { MqttClient } from '@/tcode/MqttClient'
import {userIsOffline} from "../../../api/platform/bridge";
import * as auth from "@/api/platform/auth";
import MemberDialog from "../member/preMember";

export default {
  components: {
    NumSlider,Edit,VerticalSlider,LineChart,MemberDialog
  },
  name: 'RemotePlay',
  data() {
    return {
      mqttClient: null,
      player: TCodeProfilePlayer.getInstance(),
      HOME: "L05050S1000 L15050S1000 L25050S1000 R05050S1000 R15050S1000 R25050S1000 V00000S1000 V10000S1000 V20000S1000 V30000S1000 A05050S1000 A15050S1000 A20000S1000 A35050S1000",
      //输出串口
      outSerial: {
        isConnected: false,
        sendData: '',
        receivedData: '',
        conInfo: '',
      },
      user: {
        avatarImg1: require("@/assets/avatar/default-avatar.png"),
        avatarImg2: require("@/assets/avatar/default-avatar.png"),
      },
      dots: [1, 2, 3, 4, 5],
      currentDot: 0,
      animationInterval: null,
      joystickValue: 50,
      activeTab: 'CustomMotions', // 当前激活的标签页
      showEditModal: false,
      showScopeSetting: false,
      isStartRemotePlay: false,
      editingItem: null,
      motionItems: [],
      listSize:'',
      profile: {},
      searchResultForm: {
        roomId: '',//房间ID
        userRole: '',//角色
        userRoleView: '',//角色
        onLine: 0,//在线人数
        duration: '10',//时长
        createdTime: '',//房间创建时间
        curTime: '',//当前时间
      },
      isCreate: false,
      elapsedTime: 0, //记录经过的时间
      loopType: 1, //设备循环方式1=列表循环，2=单曲循环，3=列表随机
      profileIndex: -1, // 当前播放的索引
      profileIndexNext: 0,
      sliderValues: {
        L0: [0, 9999],
        L1: [0, 9999],
        L2: [0, 9999],
        R0: [0, 9999],
        R1: [0, 9999],
        R2: [0, 9999]
      },
      width: 400,
      height: 100,
      startY: 70,
      endY: 30,
      startPoint: { x: 20, y: 50 },
      endPoint: { x: 380, y: 50 },
      l0: 50,
      fx: 50,
      pathData: '',
      sliderValue: [30, 70],
      mqttStatus: {
        connected: false,
        error: null
      },
      checkInterval: null,
      countdownInterval: null,
      statusCheckInterval: null,
      isChecking: false,
      remainingSeconds: 0,//房间剩余时间
      channels: {
        L0: { name: 'L0', data: [], color: '#FF6384' },
        L1: { name: 'L1', data: [], color: '#36A2EB' },
        L2: { name: 'L2', data: [], color: '#FFCE56' },
        R0: { name: 'R0', data: [], color: '#4BC0C0' },
        R1: { name: 'R1', data: [], color: '#9966FF' },
        R2: { name: 'R2', data: [], color: '#FF9F40' }
      },
      timeWindow: 100, // 时间窗口大小（秒）
      isShowingPermissionError: false,
      isShowingConnectedError: false,
      isRecipientStartRemotePlay: false, //受控制侧开始播放
      remainingTimeDisplay: '10:00', // 初始显示10:00
      initialRemainingTime: null,
      intServerTime: 0,
      showMemberDialog: false,
      isMember: false, // 是否会员
      isMyDevice: false,//是否本公司设备
    }
  },
  computed: {
    isRecipient() {
      return (this.searchResultForm.userRole == 1 && !this.isCreate) ||
        (this.searchResultForm.userRole == 2 && this.isCreate);
    }
  },
  mounted() {
    // 监听连接状态变化
    this.$serialPort.on('connection-change', ({isConnected}) => {
      this.outSerial.isConnected = isConnected;
    });

    // 监听数据接收
    this.$serialPort.on('data-received', (data) => {
      this.outSerial.receivedData += data;
    });

    //启动任务定时器-访问后台查询房间信息确定对方用户在线离线（5秒执行一次）
    this.startStatusChecker();
  },
  methods: {

    getUrlByKey(key) {
      // 1. 检查字符串是否为空
      if (!key || typeof key !== 'string') {
        this.user.avatar = require("@/assets/avatar/default-avatar.png");
      }
      // 2. 查找最后一个斜杠的位置
      const lastSlashIndex = key.lastIndexOf('/');
      if (lastSlashIndex === -1) {
        this.user.avatar = require("@/assets/avatar/default-avatar.png");
      }
      // 3. 获取最后一个斜杠后的部分
      const lastPart = key.slice(lastSlashIndex + 1);
      if(this.isCreate === "true") {
        if ("avt_1.png".endsWith(lastPart)) {
          this.user.avatarImg1 = require("@/assets/avatar/avatar1.png");
        } else if ("avt_2.png".endsWith(lastPart)) {
          this.user.avatarImg1 = require("@/assets/avatar/avatar2.png");
        } else if ("avt_3.png".endsWith(lastPart)) {
          this.user.avatarImg1 = require("@/assets/avatar/avatar3.png");
        } else {
          this.user.avatarImg1 = require("@/assets/avatar/default-avatar.png");
        }
        this.user.avatarImg2 = require("@/assets/avatar/default-avatar.png");
      }else{
        if ("avt_1.png".endsWith(lastPart)) {
          this.user.avatarImg2 = require("@/assets/avatar/avatar1.png");
        } else if ("avt_2.png".endsWith(lastPart)) {
          this.user.avatarImg2 = require("@/assets/avatar/avatar2.png");
        } else if ("avt_3.png".endsWith(lastPart)) {
          this.user.avatarImg2 = require("@/assets/avatar/avatar3.png");
        } else {
          this.user.avatarImg2 = require("@/assets/avatar/default-avatar.png");
        }
        this.user.avatarImg1 = require("@/assets/avatar/default-avatar.png");
      }
    },
    getUserInfo() {
      user.get(cache.getUserInfo().pk).then(result => {
        this.getUrlByKey(result.data.pk_pic);
        this.user.nickname = result.data.displayName;
        this.emailForm.currentEmail = result.data.email;
      }).catch(error => {
      });
    },
    checkPermissionsNotInRoom() {
      if (this.isShowingPermissionError) return false;
      console.log('---this.searchResultForm.onLine：'+this.searchResultForm.onLine);
      // 对方未加入房间
      if (this.searchResultForm.onLine != 2) {
        this.isShowingPermissionError = true;
        this.$message({type: "error", message: this.$t('motion_the_other_party_is_not_in_room')});
        setTimeout(() => this.isShowingPermissionError = false, 3000);
        return false;
      }
      return true;
    },
    checkPermissionsUnavailable() {
      if (this.isShowingPermissionError) return false;

      // 受控制方不能操作
      if ((this.searchResultForm.userRole == 1 && !this.isCreate) ||
        (this.searchResultForm.userRole == 2 && this.isCreate)) {
        this.isShowingPermissionError = true;
        this.$message({type: "error", message: this.$t('motion_unavailable_tips')});
        setTimeout(() => this.isShowingPermissionError = false, 3000); // 3秒内不再提示
        return false;
      }

      return true;
    },
    //校验设备及用户是否为会员
    checkDeviceAndMember(){
      if(!this.isMyDevice){
        if(!this.isMember){
          this.showMemberDialog = true;
          return;
        }
      }
      return true;
    },
    closeMemberDialog() {
      alert("this.showMemberDialog");
      this.showMemberDialog = false;
      alert(this.showMemberDialog);
    },
    checkIsConnected() {
      if (this.isShowingConnectedError) return false;
      // 受控制方提示：未连接设备
      if(!this.outSerial.isConnected && ((this.searchResultForm.userRole == 1 && !this.isCreate) ||
        (this.searchResultForm.userRole == 2 && this.isCreate))){
        this.isShowingConnectedError = true;
        this.$message({type: "error", message: this.$t('motion_device_not_connected')});
        setTimeout(() => this.isShowingConnectedError = false, 3000); // 3秒内不再提示
        return false;
      }
      if(!this.$serialPort.snCode){
        this.$serialPort.readSNCode();
      }
      return true;
    },
    async startRemotePlay(){
      // 受控制方点击“开始”按钮,表示受控制方已准备好
      if ((this.searchResultForm.userRole == 1 && !this.isCreate) ||
        (this.searchResultForm.userRole == 2 && this.isCreate)) {
        if (!this.checkIsConnected()) {
          return;
        }
        await this.findDeviceIsMember(); //TODO: 临时关闭会员限制
        if(!this.showMemberDialog) {
          if (!this.checkPermissionsNotInRoom()) {
            return;
          }
          this.isRecipientStartRemotePlay = true;
          this.checkAndSubscribe();
        }
      } else {
        if (!this.checkPermissionsNotInRoom()) {
          return;
        }
        if (this.outSerial.isConnected) {
          await this.findDeviceIsMember(); //TODO: 临时关闭会员限制
        }
        if (this.isStartRemotePlay === true) {
          return;
        }
        this.isStartRemotePlay = true;

        if (this.profileIndex === -1) {
          this.profileIndex = 0;
          this.profile = this.motionItems[this.profileIndex];
        }
        this.profileRun();
      }
    },
    stopRemotePlay(){
      if ((this.searchResultForm.userRole == 1 && !this.isCreate) ||
        (this.searchResultForm.userRole == 2 && this.isCreate)) {
        if (this.isRecipientStartRemotePlay === false) {
          return;
        }
        this.isRecipientStartRemotePlay = false;
        // 新增：停止订阅
        this.unsubscribeFromControlChannel();
        // 停止播放
        this.player.stop();
        this.send(this.HOME);
      } else {
        if (this.isStartRemotePlay === false) {
          return;
        }
        this.isStartRemotePlay = false;
        // 停止播放
        this.player.stop();
        this.publishData(this.HOME);
      }
    },
    unsubscribeFromControlChannel() {
      const topic = "Bridge" + this.searchResultForm.roomId;
      try {
        this.mqttClient.unsubscribe(topic);
        console.log('Unsubscribed from control channel:', topic);
      } catch (error) {
        console.error('Failed to unsubscribe:', error);
      }
    },
    //摇杆滑动
    async onSliderChangeForL0ActionTest(channel, value) {
      if (!this.checkPermissionsUnavailable()) {
        return;
      }
      this.isStartRemotePlay = false;
      this.profileIndex = -1;
      this.player.stop();
      const rangeStr = `${channel}${value}`;
      const message = `${rangeStr}`;
      this.publish("Bridge" + this.searchResultForm.roomId, message);
      //如果控制方也连接了设备
      if(this.outSerial.isConnected){
        await this.findDeviceIsMember(); //TODO: 临时关闭会员限制
        if(!this.showMemberDialog) {
          this.$serialPort.send(rangeStr);
        }
      }
    },
    // 处理接收到的消息
    handleRemoteMessage(rangeStr, topic) {
      if (topic === "Bridge" + this.searchResultForm.roomId) {
        console.log("send:"+rangeStr)
        if (!this.checkIsConnected()) {
          return;
        }
        this.send(rangeStr);
      }
    },

    openEditModal(item) {
      // 受控制方不能操作
      if ((this.searchResultForm.userRole == 1 && !this.isCreate) ||
        (this.searchResultForm.userRole == 2 && this.isCreate)) {
        this.$message({type: "error", message: this.$t('motion_unavailable_tips')});
        return false;
      }
      if (this.isStartRemotePlay) {
        this.$message({type: "error", message: this.$t('motion_profile_playing_not_allow_edit')});
        return;
      } else {
        this.editingItem = item;
        this.showEditModal = true;
      }
    },
    closeEditModal() {
      this.showEditModal = false;
    },
    openScopeSetting(){
      // 受控制方不能操作
      if ((this.searchResultForm.userRole == 1 && !this.isCreate) ||
        (this.searchResultForm.userRole == 2 && this.isCreate)) {
        this.$message({type: "error", message: this.$t('motion_unavailable_tips')});
        return false;
      }
      if (this.isStartRemotePlay) {
        this.$message({type: "error", message: this.$t('motion_profile_playing_not_allow_edit')});
        return;
      } else {
        this.showScopeSetting = true;
      }
    },
    findProfileListByUserPk(){
      motionApi.findProfileListByUserPk(cache.getUserInfo().pk, "0").then(res => {
        if (res.data) {
          this.motionItems = res.data;
          this.listSize =  res.data.length;
        }
      });
    },
    selectProfile(index) {
      if (!this.checkPermissionsUnavailable()) {
        return;
      }
      if (!this.checkPermissionsNotInRoom()) {
        return;
      }
      this.isStartRemotePlay = true;
      this.profileIndex = index;
      this.profile = this.motionItems[this.profileIndex];
      this.profileRun();
    },
    /**
     * 运行自定义
     */
    async profileRun() {
      this.player.setCommandCallback(this.publishData);
      // 使用当前选中的profile数据
      const profileJSON = this.profile;
      try {
        const profile = MotionProfile.fromJSON(profileJSON);
        //this.sendHome();
        // 延迟确保设备就绪
        await new Promise(resolve => setTimeout(resolve, 500));
        this.player.setProfile(profile);
        this.player.runProfile();
        // 监听播放结束
        this.player.on('end', () => {
          console.log('Action mode playback completed');
        });

      } catch (error) {
        console.log('Execution of action mode failed');
      }
    },
    async publishData(data){
      if (data.trim()) {
        const message = `${data}`;
        console.log(message);
        this.publish("Bridge" + this.searchResultForm.roomId, message);
        //如果控制方也连接了设备
        if(this.outSerial.isConnected){
          await this.$serialPort.send(data);
        }
        //生成曲线图
        this.processActionMessage(data);
      }
    },

    async send(data) {
      if (data.trim()) {
        try {
          await this.$serialPort.send(data);
          //生成曲线图
          this.processActionMessage(data);
        } catch (error) {
        }
      }
    },

    onSliderChange(channel, value) {
      if (!this.profile) {
        this.profile = {};
      }
      if (!this.profile.channelRangeList) {
        this.profile.channelRangeList = [];
      }

      // 查找或创建对应的通道配置
      let range = this.profile.channelRangeList.find(r => r.name === channel);

      if (!range) {
        // 如果不存在则创建新配置
        range = { name: channel, min: value[0], max: value[1] };
        this.profile.channelRangeList.push(range);
      } else {
        // 更新现有配置
        range.min = value[0];
        range.max = value[1];
      }
    },
    cancelScopeSetting(){
      this.showScopeSetting = false;
    },
    confirmScopeSetting(){
      try {
        this.profile.pk_user = cache.getUserInfo().pk;
        this.profile.deviceType = "0";
        motionApi.updateAllProfileAxisRangeOfUser(this.profile).then(result => {
          this.$message({
            duration: 1500,
            message: this.$t('layout_operate_sucess'),
            type: 'success'
          });
        }).catch(error => {
        })
      } catch (error) {
        this.$message({
          duration: 1500,
          message: this.$t('layout_operate_failed'),
          type: 'error'
        });
      }
      this.showScopeSetting = false;
    },
    //启动任务定时器-访问后台查询房间信息确定对方用户在线离线（5秒执行一次）
    async checkRoomStatus() {
      try {
        // 这里替换为实际的API调用
        const result = await bridgeApi.getMagpieBridgeBean(this.searchResultForm.roomId);

        if (result.data) {
          console.log("sendState:", result.data.sendState);
          console.log("receiveState:", result.data.receiveState);
          // 确定对方用户在线
          if (result.data.sendState == 2 && result.data.receiveState == 2) {
            this.searchResultForm.onLine = 2;
            if(this.isCreate === "true") {
              this.user.avatarImg2 = require("@/assets/remote/logo_square.png");
            } else {
              this.user.avatarImg1 = require("@/assets/remote/logo_square.png");
            }
          } else {
            this.searchResultForm.onLine = 1; // 设置为不在线状态
            if(this.isCreate === "true") {
              this.user.avatarImg2 = require("@/assets/avatar/default-avatar.png");
            } else {
              this.user.avatarImg1 = require("@/assets/avatar/default-avatar.png");
            }
            if (this.player && this.player.isRunning()) {
              // 停止播放
              this.player.stop();
              this.$message({type: "error", message: this.$t('motion_the_other_party_is_not_in_room')});
            }
          }
          this.searchResultForm.createdTime = result.data.createdTime;//创建时间
          this.searchResultForm.curTime = result.data.curTime;//当前时间

        } else {
          this.searchResultForm.onLine = 0; // 设置为无结果状态
          //this.$message({type: "error", message: this.$t('remote_join_room_query_nothing')});
        }

      } catch (error) {
        console.log(this.$t('remote_join_room_query_nothing'));
        this.searchResultForm.onLine = 0; // 设置为错误状态
      } finally {
        // 无论成功失败，都确保下次检查会执行
        if (this.checkInterval) {
          // 这里不需要做任何事，因为外部定时器会继续触发
        }
      }
    },
    getServerTime(){
      auth.getServerTime().then(res => {
        if (res.data) {
          const serverTimeTemp = Date.parse(res.data);
          const nowTemp = new Date();
          //计算服务器时间与当前时间的差
          this.intServerTime = Math.max(0, serverTimeTemp - nowTemp);
        }
      });
    },
    //计算房间剩余时间
    calRemainingTime() {

        const now = new Date();
        const createdTime = Date.parse(this.searchResultForm.createdTime);
        const roomTimeLimit_ms = 10 * 60 * 1000; // 10分钟

        // 计算剩余时间（毫秒），并确保 >= 0
        let remainingTime = Math.max(0, createdTime + roomTimeLimit_ms - now - this.intServerTime);

        // 转换为分钟和秒（必须取整！）
        const minutes = Math.floor(remainingTime / (60 * 1000)); // 确保分钟 <= 59
        const seconds = Math.floor((remainingTime % (60 * 1000)) / 1000);

        // 格式化为两位数
      if(remainingTime>0){
        this.remainingTimeDisplay = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      } else {
        this.remainingTimeDisplay = `00:00`;
      }

        // 更新剩余秒数（用于超时检查）
        this.remainingSeconds = Math.floor(remainingTime / 1000);

        if (this.remainingSeconds <= 0) {
          this.handleTimeExpired();
        }


      this.elapsedTime++;
    },

    handleTimeExpired() {
      this.remainingTimeDisplay = '00:00';
      // 取消订阅
      this.mqttClient.unsubscribe("Bridge" + this.searchResultForm.roomId, this.handleRemoteMessage);
      this.mqttClient.disconnect();
      // 停止播放
      this.player.stop();
      // 停止状态检查
      this.stopStatusChecker();
    },
    // 启动定时器
    startStatusChecker() {
      // 先停止已有的定时器
      this.stopStatusChecker();

      // 立即执行一次检查
      this.checkRoomStatus();

      // 1. 每秒更新倒计时
      this.countdownInterval = setInterval(() => {
        this.calRemainingTime();
      }, 1000);

      // 2. 每5秒检查一次房间状态
      this.statusCheckInterval = setInterval(async () => {
        if (!this.isChecking) {
          this.isChecking = true;
          try {
            await this.checkRoomStatus();
          } finally {
            this.isChecking = false;
          }
        }
      }, 5000);
    },

    // 停止定时器
    stopStatusChecker() {
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
      }
      if (this.statusCheckInterval) {
        clearInterval(this.statusCheckInterval);
        this.statusCheckInterval = null;
      }
      this.isChecking = false;
    },

    //连接服务器
    connectToBroker() {
      const brokerUrl = 'wss://miraplay.fun:8018/mqtt';
      const options = {
        username: 'tcode',
        password: 'Youqi1234.',
        connectTimeout: 4000,
        cleanSession: false,
        keepAlive: 60
      };
      this.mqttClient.connect(brokerUrl, options)
    },

    //发布消息@topic主题  @message发布内容
    publish(topic, message) {
      try {
        this.mqttClient.publish(topic, message, { qos: 1 }); // 使用QoS 1确保消息送达
        console.log('MQTT publish:', topic);
        return true;
      } catch (error) {
        console.error('Failed to publish message:', error);
        return false;
      }
    },

    //监听服务器是否连接失败
    mqttError() {
      this.mqttClient.on('error', (error) => {
         console.log('connection failed：',error)
        this.mqttClient.end()
      })
    },
    // 处理断开连接
    handleDisconnect() {
      this.mqttClient.end()
      console.log('MQTT disconnected')
    },
    setupMqttCallbacks() {
      console.log('setupMqttCallbacks')
      this.mqttClient.onConnect = () => {
        console.log('MQTT Connection successful');
        this.mqttStatus.connected = true;

        // 受控方需要订阅控制主题
        console.log('---userRole：'+this.searchResultForm.userRole);
        console.log('---isCreat：'+this.isCreate);
        this.handleMqttConnect();
      };

      this.mqttClient.onError = (error) => {
        console.error('MQTT error:', error);
        this.mqttStatus.error = error;
      };

      this.mqttClient.onClose = () => {
        console.log('MQTT close');
        this.mqttStatus.connected = false;
      };
    },
    handleMqttConnect() {
      console.log('MQTT Connection successful');
      this.mqttStatus.connected = true;

      // 每次连接都检查是否需要订阅
      this.checkAndSubscribe();
    },

    checkAndSubscribe() {
      if (((this.searchResultForm.userRole == 1 && !this.isCreate) ||
        (this.searchResultForm.userRole == 2 && this.isCreate)) &&
        this.isRecipientStartRemotePlay) {
        this.subscribeToControlChannel();
      }
    },
    subscribeToControlChannel() {
      const topic = "Bridge" + this.searchResultForm.roomId;
      this.mqttClient.subscribe(topic, this.handleRemoteMessage);
      console.log('Subscribed to control channel:', topic);
    },
    //监听服务器重新连接
    reconnect() {
      this.client.on('reconnect', (error) => {
        // console.log('正在重连:', error)
      });
    },

    processActionMessage(message) {
      console.log('Processing action message:', message);

      // 拆分消息中的各个通道数据
      const commands = message.split(" ");
      const timestamp = Date.now();

      // 解析每个命令并更新对应图表
      commands.forEach(cmd => {
        if (!cmd) return;

        try {
          const channel = cmd.substring(0, 2); // 提取通道名 (L0, L1, etc.)
          const valueStr = cmd.substring(2);   // 提取剩余部分

          // 提取数值部分 (处理可能的后缀如S1000)
          let value;
          if (valueStr.includes('S')) {
            value = parseInt(valueStr.split('S')[0]);
          } else if (valueStr.includes('I')) {
            value = parseInt(valueStr.split('I')[0]);
          } else {
            value = parseInt(valueStr);
          }
          // 确保数值在0-9999范围内
          const clampedValue = Math.max(0, Math.min(9999, value));
          console.log(`Channel: ${channel}, Value: ${value}`);

          // 调用对应图表的addDataPoint方法
          if (this.$refs[`chart${channel}`]) {
            this.$refs[`chart${channel}`].addDataPoint(clampedValue);
          } else {
            console.warn(`No chart found for channel: ${channel}`);
          }
        } catch (e) {
          console.error('Error processing command:', cmd, e);
        }
      });
    },
    userIsOffline() {
      try {
        const bridgeData = {
          code: this.searchResultForm.roomId
        };
        // 这里替换为实际的API调用
        const result = bridgeApi.userIsOffline(this.searchResultForm.userRole,bridgeData);
        if (result.data) {
          console.log('userIsOffline:', result.data)
          this.checkRoomStatus()
        }
      } catch (error) {
      } finally {
      }
    },
    //获取用户是否为会员
    findUserIsMember() {
      const pk_user = cache.getUserInfo().pk;
      auth.judgeIsMember(pk_user).then(res => {
        if (res.data == "Y") {
          this.isMember = true;
        }
      }).catch(error => {
      });
    },
    //获取设备是否为本公司设备
    async findDeviceIsMember() {
      //获取用户是否为会员
      this.findUserIsMember();
      if(!this.$serialPort.snCode){
        this.$serialPort.readSNCode();
      }
      await auth.findDeviceByCode(this.$serialPort.snCode).then(res => {
        if (res.data == "Y") {
          this.isMyDevice = true;
        }else{
          if(!this.isMember){
            this.showMemberDialog = true;
          }
        }
      }).catch(error => {
      });
    },
  },
  // 初始化调用方法
  created () {
    const clientIdPrefix = this.isCreate ? 'controller_' : 'controlled_';
    this.mqttClient = new MqttClient(clientIdPrefix + Date.now());
    // 设置MQTT回调
    this.setupMqttCallbacks();
    // 连接MQTT服务器
    this.connectToBroker();
    // 获取服务器时间
    this.getServerTime();

    this.searchResultForm.roomId = this.$route.query.roomId;
    const user = appGlobal.getData(cache.getUserInfo().pk);
    if (user && user.roomIdt === this.$route.query.roomId) {
      if(user.isCreatt === "Y"){
        this.isCreate = "true";
      } else {
        this.isCreate = "false";
      }
    } else {
      this.isCreate = this.$route.query.isCreate;
    }

    this.searchResultForm.userRole = this.$route.query.userRole;
    this.getUserInfo();
    this.findProfileListByUserPk();
    this.outSerial.conInfo = this.$serialPort.getPortInfo();
    if (this.outSerial.conInfo.isConnected == true) {
      this.outSerial.isConnected = true;
    } else {
      this.outSerial.isConnected = false;
    }
    if (((this.searchResultForm.userRole == 1 && !this.isCreate) ||
      (this.searchResultForm.userRole == 2 && this.isCreate)) && this.isRecipientStartRemotePlay) {
      this.mqttClient.subscribe("Bridge" + this.searchResultForm.roomId, this.handleRemoteMessage);
    }
  },
  beforeDestroy() {
    this.elapsedTime = 0;
    //用户离线
    this.userIsOffline()
    // 取消订阅
    this.mqttClient.unsubscribe("Bridge" + this.searchResultForm.roomId, this.handleRemoteMessage);
    this.mqttClient.disconnect();
    // 停止播放
    this.player.stop();

    // 停止状态检查
    this.stopStatusChecker();
  }
}
</script>

<style scoped>
.remote-play-container {
  width: 100%;
  min-width: 1200px; /* 根据内容设置最小宽度 */
  height: 100%;
  overflow: auto; /* 添加滚动条 */
  padding: 20px;
  box-sizing: border-box;
}

.tab-header {
  display: inline-flex; /* 改为 inline-flex 以便实现靠左对齐 */
  margin-bottom: 20px;
  border-bottom: 1px solid #e0e0e0;
}
.left-section {
  width: 500px;
  background-color: #ffffff;
  padding: 20px;
  border-radius: 8px;
}

.right-section {
  width: 600px;
  background-color: #ffffff;
  padding: 20px;
  border-radius: 8px;
  text-align: center; /* 添加这一行 */
}

.tab-content {
  padding: 0 15px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: #333;
}

.form-group input,
.form-group select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}
.form-profile {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.form-profile label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: #333;
}

.form-profile input,
.form-profile select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.avatar-container {
  display: flex;
  justify-content: space-between;
  align-items: center; /* 垂直居中 */
  width: 100%;
  margin-bottom: 20px;
}

.avatar-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.avatar-label {
  margin-top: 15px;
  font-size: 14px;
  color: #333;
}
.avatar {
  width: 100px; /* 调整头像大小 */
  height: 100px; /* 调整头像大小 */
  border-radius: 4px; /* 保持方形边框 */
  border: 1px solid #8300F6; /* 添加紫色边框，调整粗细 */
  object-fit: cover; /* 保持图片比例 */
}
.avatar2 {
  width: 100px; /* 调整头像大小 */
  height: 100px; /* 调整头像大小 */
  border-radius: 4px; /* 保持方形边框 */
  border: 1px solid #A9A9A9; /* 添加紫色边框，调整粗细 */
  object-fit: cover; /* 保持图片比例 */
}

.dots {
  display: flex;
  justify-content: center;
  align-items: center; /* 垂直居中 */
  margin: 0 20px;
}

.dots span {
  width: 12px; /* 稍微增大圆点 */
  height: 12px;
  background-color: #999;
  border-radius: 50%;
  margin: 0 8px; /* 增加圆点间距 */
  transition: all 0.3s ease;
}
.dots span.online {
  background-color: #8300F6; /* 紫色 */
}
.dots span.active {
  background-color: #8300F6; /* 使用主题紫色 */
  transform: scale(1.2); /* 激活状态稍微放大 */
}

.button-container {
  width: 350px;
  padding: 10px 50px;
  display: flex;
  justify-content: space-between; /* 改为 space-between 让元素均匀分布 */
  align-items: center;
  background-color: #d9d7f5;
  border-radius: 4px;
  margin-bottom: 25px;
  border: 1px solid #8300F6;
}

/* 新增按钮组样式 */
.button-group {
  display: flex;
  align-items: center;
  gap: 5px; /* 调整标签和图片之间的间距 */
}

/* 调整图片按钮的间距 */
.image-button {
  background-color: #d9d7f5;
  border: none;
  padding: 0;
  margin: 0 15px; /* 增加左右间距 */
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.button-image {
  object-fit: cover;
  border: none; /* 移除边框 */
}

.image-button:hover {
  transform: scale(1.05); /* 悬停效果 */
}
.joystick-settings {
  margin-top: 10px;
  width: 100%;
}

.joystick-container {
  display: flex;
  align-items: center;
  gap: 20px; /* Adjust the space between joystick and slider */
}

.joystick-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 60px; /* Ensure consistent width for the joystick area */
}
.joystick-label {
  margin-top: 8px;
  font-size: 14px;
  color: #333;
}
.slider-group {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.slider-title {
  font-size: 14px;
  color: #333;
  margin-bottom: 18px;
  margin-left: 10px; /* Align with slider's left edge */
}

.slider-container {
  width: 100%;
}
/* 分隔线 */
.mira-form-divider {
  position: relative;
  margin: 0 ;
  color: #bfbcbc;
  margin-bottom: 30px;
}

.mira-form-divider:before,
.mira-form-divider:after {
  content: "";
  position: absolute;
  top: 15px;
  width: 100%;
  height: 1px;
  background-color: #cdc9c9;
}

.mira-form-divider:before {
  left: 0;
}

.mira-form-divider:after {
  right: 0;
}
/* 下拉箭头样式 */
select {
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 14px;
  padding-right: 30px;
}

/* 新增的双栏布局样式 */
.two-column-layout {
  display: flex;
  width: auto; /* 改为auto而不是100% */
  max-width: none; /* 移除最大宽度限制 */
  margin: 0; /* 移除自动外边距 */
  justify-content: flex-start; /* 确保内容靠左 */
}


.section-gap {
  width: 20px; /* 间隔大小 */
  flex-shrink: 0;
}

/* 确保内容不会导致滚动条 */
.form-group input,
.form-group select {
  box-sizing: border-box;
}
.motion-item {
  padding: 7px;
  margin-bottom: 4px; /* 行与行之间的间隔 */
  background-color: #F4F1FAFF; /* 背景色 */
  border-radius: 2px; /* 圆角 */
  transition: background-color 0.3s;
}
.motion-item:hover {
  background-color: #f0e0ff; /* 悬停效果 */
}

.selected-item {
  background-color: #f9f0ff; /* 选中项背景色 */
}
.item-content {
  display: flex;
  align-items: center;
  width: 100%;
}
.slider-item {
  padding: 15px;
  margin-bottom: 10px; /* 行与行之间的间隔 */
  background-color: #F4F1FAFF; /* 背景色 */
  border-radius: 2px; /* 圆角 */
}

.icon-container {
  margin-right: 10px;
}

.text-container {
  flex: 1;
  font-size: 16px;
  color: #333;
  cursor: pointer; /* 添加手型光标 */
  transition: color 0.3s; /* 添加颜色过渡效果 */
  padding: 8px 0; /* 增加点击区域 */
}

.edit-container {
  margin-left: 10px;
}
.motion-item .item-content {
  justify-content: flex-start; /* Keep items aligned left for the list items */
}
.edit-container button {
  background: none;
  border: none;
  cursor: pointer;
}

.edit-container img {
  width: 20px;
  height: 20px;
  margin-bottom: 5px; /* 调整间距 */
}
.edit-container-item  button{
  background: none;
  border: none;
  cursor: pointer;
}
.edit-container-item img {
  width: 16px;
  height: 16px;
}
.slider-label {
  width:30px;
  margin-right: 20px; /* 调整间距 */
}

/* 方法 1B：在 NumSlider 上添加 margin-left */
.slider-control {
  margin-left: 10px; /* 调整间距 */
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* 确保模态框在最上层 */
}
.dialog-buttons {
  display: flex;
  justify-content: center; /* 水平居中 */
  gap: 30px; /* 加大按钮之间间隔，你可以根据需要调整数值 */
  margin-top: 10px;
}

.dialog-btn {
  padding: 8px 35px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.cancel-btn {
  background-color: #F4F3F1;
  color: #AA81FF;
  border: 1px solid #AA81FF;
}

.cancel-btn:hover {
  background-color: #e0e0e0;
}

.confirm-btn {
  background-color: #AA81FF;
  color: white;
  border: none;
}

.confirm-btn:hover {
  background-color: #7200D6;
}
.avatar-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.avatar-dialog {
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  width: 450px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.avatar-dialog h3 {
  margin-top: 0;
  margin-bottom: 20px;
  text-align: left;
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 400;
}
<!---------------------->
    .container {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

.curve-panel {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}

.vertical-slider-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100px;
}

/* 垂直滑杆样式 */
.vertical-slider {
  -webkit-appearance: slider-vertical;
  width: 20px;
  height: 100px;
  background: transparent;
  accent-color: purple;
  writing-mode: bt-lr; /* IE 支持 */
  /*appearance: slider-vertical;*/
}

svg {
  background-color: transparent;
  border-radius: 10px;
}

rect {
  fill: #e6e6ff;
  stroke: none;
  rx: 10;
  ry: 10;
}

.controls {
  display: flex;
  gap: 20px;
}

.slider-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

label {
  font-size: 14px;
  color: purple;
}

input[type="range"] {
  width: 200px;
  accent-color: purple;
}

span {
  font-size: 14px;
  color: purple;
}

.chart-grid {
  display: grid;

  grid-gap: 5px;
}

.chart-item {

  border-radius: 2px;
  padding: 5px;
  transition: all 0.3s ease;
}

.chart-title {
  text-align: center;
  font-weight: bold;
  margin-bottom: 5px;
  font-size: 14px;
  color: #7200D6;
}
/* 平滑的X轴变化 */
.echarts {
  transition: transform 0.3s ease-out;
}
.disabled-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(248, 244, 244, 0.7);
  z-index: 10;
  border-radius: 8px;
  pointer-events: none; /* 允许点击穿透 */
}
.content-disabled {
  pointer-events: none; /* 禁用所有鼠标事件 */
  opacity: 0.7; /* 可选：使内容看起来被禁用 */
}
.time-remaining {
  margin-left: 10px;
  color: #8300F6;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/pages/tcode/remote/room.vue